import Vue from 'vue';
import VueFacebookPixel from 'vue-facebook-pixel';

Vue.use(VueFacebookPixel);
Vue.analytics.fbq.init(process.env.VUE_APP_FACEBOOK_PIXEL_KEY, {
    em: ''
})